import { render, staticRenderFns } from "./batchAcount.vue?vue&type=template&id=2a2993a8&scoped=true&"
import script from "./batchAcount.vue?vue&type=script&lang=js&"
export * from "./batchAcount.vue?vue&type=script&lang=js&"
import style0 from "./batchAcount.vue?vue&type=style&index=0&id=2a2993a8&lang=less&scoped=true&"
import style1 from "./batchAcount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2993a8",
  null
  
)

export default component.exports